<template>
  <b-modal
    v-model="editorShown"
    title="Share Document"
    @hidden="onHidden"
    centered
    scrollable
    size="md"
    no-close-on-backdrop
    header-bg-variant="primary"
    header-text-variant="white"
    header-class="bg-purple"
  >
    <b-row>
      <b-col>
        <div class="text-left">
          <b-form-group label="Share with">
            <b-form-checkbox-group
              v-model="shareWith"
              stacked
              name="share-with"
            >
              <b-form-checkbox
                v-for="(access, index) in portalAccesses"
                :key="index"
                :value="access.id"
              >
                <b>{{ access.name }}</b> ({{ access.relationship }})
              </b-form-checkbox>
            </b-form-checkbox-group>

            <b-alert v-if="portalAccesses.length == 0" show variant="warning"
              >There's no granted users</b-alert
            >
          </b-form-group>

          <b-form-group label="Mode">
            <b-form-radio-group v-model="readonly" stacked>
              <b-form-radio v-if="showFormMode" :value="false">
                Editable
                <small>(The document can be modified in the portal) </small>
              </b-form-radio>
              <b-form-radio :value="true">
                Read-only
                <small>
                  (The document can only be viewed in the portal)
                </small>
              </b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </div>
      </b-col>
    </b-row>

    <template v-slot:modal-footer>
      <div class="text-right mt-1 mr-2">
        <b-button variant="secondary" @click="onHidden">Cancel</b-button>
        <b-button
          class="ml-2"
          variant="primary"
          @click.prevent="sendLink"
          :disabled="shareWith.length === 0"
        >
          Share
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapActions } from "vuex";
import portalAccessServer from "../../../server/portalAccess";
import portalDocumentServer from "../../../server/portalDocument";
import documentGroupServer from "../../../server/documentGroup";

export default {
  name: "DocumentShareMultipleModal",
  props: ["patientId", "eocId", "forms"],
  data() {
    return {
      shareWith: [],
      readonly: true,
      portalAccesses: [],
      documentGroups: []
    };
  },
  async mounted() {
    this.portalAccesses = await portalAccessServer.findAllAccess(
      this.patientId
    );

    if (this.anyDocumentGroup) {
      const ids = this.forms
        .filter(u => u.documentGroupId)
        .map(u => u.documentGroupId);

      this.documentGroups = await documentGroupServer.documentGroupsFromIds(
        ids
      );
    }
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    async sendLink() {
      var documents = [];
      if (this.anyDocument) {
        documents.push({
          documentId: this.forms[0].documentId,
          readonly: this.readonly
        });
      } else if (this.anyDocumentGroup) {
        documents.push({
          documentId: this.forms[0].documentGroupId,
          readonly: this.readonly
        });
      }
      await portalDocumentServer.shareDocuments({
        portalAccessIds: this.shareWith,
        documents: documents,
        episodeOfCareId: this.eocId
      });

      this.showAlertSuccess();
      this.$emit("onModify");
    },
    onHidden() {
      this.$emit("onModify");
    }
  },
  computed: {
    editorShown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    showFormMode() {
      if (this.anyDocument) {
        return !this.forms.some(
          f => f.status === "Completed" || f.mode === "File"
        );
      }
      return this.documentGroups.some(documentGroup =>
        documentGroup.results.some(document => document.status !== "Completed")
      );
    },
    anyDocument() {
      return this.forms.some(u => u.documentId);
    },
    anyDocumentGroup() {
      return this.forms.some(u => u.documentGroupId);
    }
  }
};
</script>

<style scoped>
.prepend-send {
  width: 170px;
}
</style>
